/**
 * Base url of a shop's own `api` project.
 *
 * VCE and HVO each run their own api against their own Firestore/Pay. service, so anything
 * that has to act on a specific order (payment links, nabetaling mails, cancels) must be
 * sent to that order's shop - the other api simply doesn't know the order.
 */
export const resolveShopApiUrl = (shopSource) =>
  shopSource === "HVO" ? process.env.REACT_APP_HVO_API_URL : process.env.REACT_APP_VCE_API_URL;
